/** @jsxImportSource @emotion/react */
import { Fragment } from 'react';

import { ACTIVITY_LOG_SEPARATOR } from '@/Client/Lib';
import type { ScanPartFieldChange } from '@/Client/Presenters';
import { DEFAULT_TASK_ACTIVITY_LOG_STYLES } from './taskActivityLogStyles';

const styles = DEFAULT_TASK_ACTIVITY_LOG_STYLES;

/**
 * An update's changes on one line: "Qty: ~~2~~ → 4  ·  Parts: ~~$30.00~~ → $45.00  ·  Deferred added", the old value
 * struck through. A modifier change reads by its name alone.
 */
export const TaskActivityChangesSummary = ({ changes }: { changes: readonly ScanPartFieldChange[] }) => (
  <span data-testid={'task-activity-changes-summary'}>
    {changes.map(({ field, before, after, isModifier }, index) => (
      <Fragment key={field}>
        {index > 0 && ACTIVITY_LOG_SEPARATOR}
        {isModifier ? field : (
          <>
            {`${field}: `}
            {before !== undefined && (
              <>
                <span css={styles.detailBefore}>{before}</span>
                {' → '}
              </>
            )}
            {after ?? '—'}
          </>
        )}
      </Fragment>
    ))}
  </span>
);
